import Vue from 'vue'

const tableFactory = (overrides = {}) => ({
  name: null,
  service: null,

  // current table index (current state)
  page: 0,

  // display records per page
  perPage: 12,

  // string filter
  search: '',
  searchIn: [],

  // categorical filter
  filters: [],
  filtersValues: {},

  sortIndex: 0,
  sortOptions: [
    {
      labelKey: 'sort.new',
      sort: {
        id: -1,
      },
    },
    {
      labelKey: 'sort.old',
      sort: {
        id: 1,
      },
    },
  ],
  dataColumns: [],

  // query appended before being executed
  customQuery: {},

  // display results in columns
  tableBreakpoint: 'sm',
  columns: {
    xl: 3,
    lg: 2,
    xs: 1,
  },

  ...overrides,
})

export default {
  store: {
    state: {
      tables: [],
    },
    actions: {
      CLEAR_TABLES({ commit }) {
        commit('CLEAR_TABLES')
      },
      PUSH_TABLE({ commit }, table) {
        commit('PUSH_TABLE', table)
      },
      PATCH_TABLE({ commit }, { table, ...patch }) {
        commit('PATCH_TABLE', { table, ...patch })
      },
      SET_TABLE_FILTER({ commit }, { table, label, value }) {
        commit('SET_TABLE_FILTER', { table, label, value })
      },
      RESET_TABLE_FILTER({ commit }, table) {
        commit('RESET_TABLE_FILTER', table)
      },
    },
    mutations: {
      CLEAR_TABLES(state) {
        state.tables = []
      },
      SET_TABLE_FILTER(_, { table, label, value }) {
        if (typeof table.filters[label] === 'undefined') {
          Vue.set(table.filtersValues, label, value)
        } else {
          table.filters[label] = value
        }
      },
      RESET_TABLE_FILTER(_, table) {
        Vue.set(table, 'filtersValues', {})
      },
      PUSH_TABLE(state, table) {
        state.tables.push(tableFactory(table))
      },
      PATCH_TABLE(_, { table, ...patch }) {
        Object
          .keys(patch)
          .forEach((key) => {
            table[key] = patch[key]
          })
      },
    },
    getters: {
      getTable: ({ tables }) => tableName =>
        tables.find(table => table.name === tableName),
    },
  },
}
